import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Hook to read the supplier's Legal account status.
 * Returns { legal, loaded, refresh } where:
 *   - legal.exists: boolean (true if the supplier has filled the form)
 *   - legal.locked: boolean (currently same as `exists`)
 *   - refresh: re-fetch (call after submitting Legal)
 *
 * Suppliers cannot publish products until `legal.exists === true`.
 */
export function useLegalAccount() {
  const [legal, setLegal] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const fetchOnce = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/account/legal`);
      setLegal(res.data || null);
    } catch (_) {
      setLegal(null);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchOnce();
  }, [fetchOnce]);

  return { legal, loaded, refresh: fetchOnce };
}
